(function() { module.exports = window["Next"]["ConfigProvider"]; }());